// 楼层
class rlFloor {
  constructor() {
    // 数据库ID
    this.ID = null;
    // 标准层ID
    this.StdFlrGuid = null;
    // 楼层名称
    this.Name = null;
    // 楼层高度
    this.Height = null;
    // 底标高
    this.LevelB = null;

    this.classTypeName = "Floor"; //楼层
  }

  add(obj) {
    this.ID = obj.ID;
    this.StdFlrGuid = obj.StdFlrGuid;
    this.Name = obj.Name;
    this.Height = obj.Height;
    this.LevelB = obj.LevelB;
  }
}

export { rlFloor };
